<template>
    <li :class="'nav-link ' + (item.children?.length > 0 ? 'dropdown ' : '') + isActiveRouter(item.module)">
        <router-link @click="$emit('linkClick')" :class="[{ active: isActiveRouter(item.module) }, !item.module ? 'no-cursor' : '', submenu ? 'p-0' : '']" :to="item.module ? ('/' + (item.module != 'inicio' ? item.module : '')) : ''">
            <!-- ✅ Caso submenu -->
            <template v-if="submenu">
                <div class="d-flex justify-content-between align-items-center w-100 ">
                <span>{{ item.module_menu }}</span>
                <i v-if="item.children.length > 0" class="bi bi-chevron-right"></i>
                </div>
            </template>

            <!-- ✅ Caso menú principal -->
            <template v-else>
                <div class="text-center">{{ item.module_menu }}</div>
                <div class="text-center">
                <i v-if="item.children.length > 0" class="bi bi-chevron-down"></i>
                <i v-else>&nbsp;</i>
                </div>
            </template>
        </router-link>
        <ul v-if="item.children.length > 0">
            <MenuItemComponent 
                v-for="child in item.children" 
                :key="child.id_module" 
                :item="child"
                :isactive="isActive"
                @linkClick="$emit('linkClick')"
            />
        </ul>
    </li>
  </template>
  
  <script>
  import { ref } from 'vue'
  
  export default {
    name: 'MenuItemComponent',
    props: {
      item: { type: Object, required: true },
      submenu: { type: Boolean, required: false, default: true },
      isactive: { type: Boolean, required: true }
    },
    setup(props) {

      const isActive = ref(false)
      isActive.value = props.isactive
      return { isActive }
    },
    methods: {
      isActiveRouter(name) {
        return this.$route.name == name ? 'active' : '';
      }
    }
  }
  </script>
  

  